import React, { useState, useEffect, useRef } from 'react';
import './VListStyles.css';
import 'react-virtualized/styles.css';

import Container from '../../ui/surfaces/Container.js'
import { ScrollSync, AutoSizer, Grid } from 'react-virtualized';
import clsx from 'clsx';
import scrollbarSize from 'dom-helpers/scrollbarSize';

import ViewHeader from '../ViewHeader.js';
import LoadingIndicator from '../../common/LoadingIndicator'
import SpreadsheetBody from './SpreadsheetBody'
import LeftSideCell from './LeftSideCell';
import {observer} from 'mobx-react-lite'
import SpreadsheetHeader from './SpreadsheetHeader'
import HeaderSelector from './HeaderSelector'

const Spreadsheet = observer(function Spreadsheet(props) {
    const screen = props.screen
    // const app_context= props.app_context
    const [focusedColumn, setFocusedColumn] = useState(-1)
    const [focusedRow, setFocusedRow] = useState(-1)
    const [columnWidthMap, setColumnWidthMap] = useState({})
    const [selectedIndex, setSelectedIndex] = useState({})
    // const [orderedColumn, setOrderedColumn] = useState({ index: false, order: false })
    const [selectedCells, setSelectedCells] = useState({})
    const gridHeader = useRef(null);
    const gridBody = useRef(null);
    const navigator = useRef(null);
    const height = props.height ? props.height - screen.header_row_height : (window.innerHeight * 75) / 100;
    const overscanColumnCount = 0;
    const overscanRowCount = 5;
    const rowHeight = screen.row_height;
    const columnCount = screen.visible_fields.length;
    const rowCount = screen.data.records.length
    const isSpreadsheet = screen.type === 'spreadsheet'
    const container_ref = React.createRef()
    const selected_records = screen.selected_records
    


    //list view methods ?
    useEffect(() => {

        let columns = [...screen.visible_fields]
        // if(columns.length){
        let map = { ...columnWidthMap }
        map.sizes = {}

        columns.forEach(function (column, index) {
            let column_width = column.width
            if(column_width && column_width.includes('%')){
                // use view width -20px (corresponding to left selection checkbox)
                column_width = (width) =>  ((width-20)*parseInt(column.width.replace('%','')))/100                
            }
            else{
                column_width = parseInt(column_width) || 200
            }
            // map.sizes[index] = parseInt(column.width) || 200;
            map.sizes[index] = column_width
        })

        setColumnWidthMap(map)
        // }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screen.visible_fields]);



    //END Hooks




    function onResizeStop({ columnIndex }) {
        let map = columnWidthMap
        map.column_on_drag = false
        setColumnWidthMap(map)
    }

    function getColumnWidth({ index, width }) {
        switch (index) {
            case 0: return 20;
            // default: return (width*33)/100
            default: {
                const size = columnWidthMap.sizes[index]
                if(!size){
                    return 200
                }
                else if (typeof size === 'function'){
                    return size(width)
                }
                else{
                    return columnWidthMap.sizes[index]
                }
                
            }
        }
    }

    


    const changeSelection = (e, rowIndex) => {
        
        screen.changeSelection({index:rowIndex})
        

    }


    

    const inSelectedRange = (key) => {
        return selectedCells.hasOwnProperty(key)
    }


    function createKey(rowIndex, columnIndex) {
        return rowIndex.toString().concat('-').concat(columnIndex.toString())
    }

    function selectRange(key, rowIndex, columnIndex) {
        let sc = {}

        let rows_to_select = []
        let columns_to_select = []

        let col_dif = columnIndex - focusedColumn
        let row_dif = rowIndex - focusedRow


        if (col_dif >= 0) {
            let col_to_select = focusedColumn
            while (col_to_select <= columnIndex) {
                columns_to_select.push(col_to_select)
                col_to_select = col_to_select + 1
            }

        }

        if (col_dif < 0) {
            let col_to_select = focusedColumn
            while (col_to_select >= columnIndex) {
                columns_to_select.push(col_to_select)
                col_to_select = col_to_select - 1
            }

        }

        if (row_dif >= 0) {
            let row_to_select = focusedRow
            while (row_to_select <= rowIndex) {
                rows_to_select.push(row_to_select)
                row_to_select = row_to_select + 1
            }
        }

        if (row_dif < 0) {
            let row_to_select = focusedRow
            while (row_to_select >= rowIndex) {
                rows_to_select.push(row_to_select)
                row_to_select = row_to_select - 1
            }
        }

        rows_to_select.forEach(function (row) {
            columns_to_select.forEach(function (col) {
                sc[createKey(row, col)] = true
            })
        })





        setSelectedCells(sc)
    }



    function hoverCell(e, key, rowIndex, columnIndex) {

        if (e.buttons) {
            e.persist()
            selectRange(key, rowIndex, columnIndex)

        }

    }


    //Renderers




    function resizeColumn({ deltaX, columnIndex, lastX, width }) {

        let map = { ...columnWidthMap }

        let current_width = map.sizes[columnIndex]
        // If type function, the current value is a %, calc it just the first time
        if(typeof current_width == 'function'){
            current_width = getColumnWidth({index:columnIndex, width})
        }
        const new_width = Math.max(50, (current_width + (deltaX - lastX)))

        map.sizes[columnIndex] = new_width
        map.column_on_drag = columnIndex

        setColumnWidthMap(map)



        gridHeader.current.recomputeGridSize({ columnIndex: 0, rowIndex: 0 })
        gridBody.current.recomputeGridSize({ columnIndex: 0, rowIndex: 0 })




    }



    function renderLeftHeaderCell({ columnIndex, key, style }) {


        return (
            <div key={key} style={style}>
                <HeaderSelector screen={screen} />
            </div>
            
        );
    }

    function renderLeftSideCell({ columnIndex, key, rowIndex, style }) {

        
        let rowClass = rowIndex % 2 === 0 ? "TableEvenRow" : "TableOddRow"
        rowClass = clsx("leftCheckbox", rowClass)
        

        return (
            <div  key={key} style={style} >
                <LeftSideCell 
                    className={rowClass}  
                   
                    // style={style} 
                    isSpreadsheet={screen.type == 'spreadsheet'}
                    screen={screen} 
                    rowIndex={rowIndex} 
                    changeSelection={changeSelection}/>
            </div>
        );
    }

    function executeAction(id, params){
        let action = props.getActionById(id)
        //reset selection in case the record is deleted
        if(action.type === 'delete_record'){
            setSelectedIndex({})
        }
        return props.executeAction(id,params)
    }




    return (
        <React.Fragment>
            <LoadingIndicator
                ref={container_ref}
                show={screen.data.loading}
                // show={true}
                // close={()=>{}}
            />
            {(!props.headless) &&
                <ViewHeader
                    screen={screen}
                    hide_toolbar={props.hide_toolbar}
                    isSpreadsheet={isSpreadsheet}
                    container_classname={props.height ? false:"rounded bg-white border border-gray-300"}
                    rowCount={rowCount}
                    {...props.header_props}
                />
            }

            <ScrollSync>
                {({
                    // clientHeight,
                    // clientWidth,
                    onScroll,
                    // scrollHeight,
                    scrollLeft,
                    scrollTop,
                    // scrollWidth,
                }) => {
                    // const x = scrollLeft / (scrollWidth - clientWidth);
                    // const y = scrollTop / (scrollHeight - clientHeight);

                    return (
                        

                        <Container type={props.container || 'paper'} className="px-2 border overflow-hidden rounded">
                            
                            <div className="GridRow">
                                <div
                                    className="LeftSideGridContainer"
                                    style={{
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,

                                    }}>
                                    <Grid
                                        cellRenderer={renderLeftHeaderCell}
                                        className={"HeaderGrid border-none"}
                                        width={20}
                                        height={rowHeight}
                                        rowHeight={rowHeight}
                                        columnWidth={getColumnWidth}
                                        rowCount={1}
                                        columnCount={1}
                                    />

                                </div>

                                <div
                                    className={"LeftSideGridContainer"}
                                    style={{
                                        position: 'absolute',
                                        left: 0,
                                        top: screen.header_row_height,

                                    }}>
                                    <Grid
                                        overscanColumnCount={overscanColumnCount}
                                        overscanRowCount={overscanRowCount}
                                        cellRenderer={renderLeftSideCell}
                                        columnWidth={getColumnWidth}
                                        columnCount={1}
                                        className={"LeftSideGrid"}
                                        height={height - scrollbarSize()}
                                        rowHeight={rowHeight}
                                        rowCount={rowCount}
                                        scrollTop={scrollTop}
                                        width={20}
                                    />


                                </div>


                                <div  ref={container_ref} className="GridColumn">
                                    <AutoSizer disableHeight>
                                        {({ width }) => (
                                            <div  >
                                                <div
                                                
                                                    style={{

                                                        height: screen.header_row_height,
                                                        width: width - scrollbarSize(),

                                                    }}>
                                                    
                                                    <SpreadsheetHeader
                                                        screen={screen}
                                                        scrollLeft={scrollLeft}
                                                        rowHeight={screen.header_row_height}
                                                        gridHeaderRef={gridHeader}
                                                        width={width}
                                                        columnWidthMap={columnWidthMap}
                                                        columnWidth={getColumnWidth}
                                                        onResizeStop={onResizeStop}
                                                        resizeColumn={resizeColumn}
                                                    />
                                                </div>

                                                
                                                    <div
                                                        
                                                        style={{

                                                            color: 'black',

                                                            width,
                                                        }}>




                                                        <SpreadsheetBody
                                                            className="BodyGrid"
                                                            screen={screen}
                                                            columnWidth={getColumnWidth}
                                                            columnCount={columnCount}
                                                            height={height}
                                                            onScroll={onScroll}
                                                            overscanColumnCount={overscanColumnCount}
                                                            // noData={props.noData}
                                                            selectedIndex={selectedIndex}
                                                            overscanRowCount={overscanRowCount}
                                                            // cellRenderer={renderBodyCell}
                                                            rowHeight={rowHeight}
                                                            rowCount={rowCount}
                                                            // ref={gridBody}
                                                            gridRef={gridBody}
                                                            width={width}
                                                            // added
                                                            // columns={props.columns}
                                                            // isSpreadsheet={isSpreadsheet}
                                                            // data={props.data}
                                                            // getLazyValues={props.getLazyValues}
                                                            // dispatch={props.dispatch}
                                                            // orderedColumn={orderedColumn}
                                                            disableAutoSave={props.disableAutoSave}
                                                            getDefaultValues={props.getDefaultValues}
                                                            onDataChange={props.onDataChange}
                                                            prepareValues={props.prepareValues}
                                                            selected_records = {selected_records}


                                                        />





                                                    </div>
                                                


                                            </div>
                                        )}
                                    </AutoSizer>
                                    {/* <div className="w-full">Footer Component Here</div> */}
                                </div>
                            </div>
                        </Container>

                    );
                }}
            </ScrollSync>
            
        </React.Fragment>


    )

}
)


export default Spreadsheet;